<template>
  <!-- Add new filter drop down-->
  <div class="custom-filter-component">
    <div
      class="filter dropdown add"
      :class="{ 'is-key-selected': activeFilter.caption }"
      v-if="activeFilter != null && isAddFilterVisible"
    >
      <div class="filter-key-search-container" v-show="!activeFilter.caption">
        <div
          class="filter-key-search"
          :class="{ active: isFilterKeySearchActive }"
        >
          <span
            class="filter-key-search-icon"
            @click="focusFilterKeySearch"
          ></span>
          <input
            ref="filterKeySearchInput"
            type="text"
            name="filter-key-search"
            v-model="filterKeySearch"
            autocomplete="off"
            placeholder="Nach Name oder Label filtern"
            @focus="isFilterKeySearchFocused = true"
            @blur="isFilterKeySearchFocused = false"
            @click.stop
            @mousedown.stop
            @keydown.stop
          />
        </div>
      </div>
      <div class="initial-dropdown-items" v-show="!activeFilter.caption">
        <b-dropdown-item
          :key="item.renderKey"
          v-for="item in filteredFilterOptions"
          @click="onFilterCaptionSelect(item.name)"
        >
          {{ formatLabel(item.label) }}
        </b-dropdown-item>
        <div class="empty-filter-option" v-show="hasNoFilterSearchResult">
          Es wurde keine passende Spalte gefunden
        </div>
      </div>
      <generalDropdown
        className="filter-dropdown key-filter-dropdown mr-3"
        :alignRight="false"
        v-show="activeFilter.caption"
      >
        <template v-slot:selectFilter>
          <span class="line-clamp">{{ activeFilter.caption }} </span>
        </template>
        <template v-slot:optionData>
          <div class="filter-option-menu-search-container">
            <div
              class="filter-key-search filter-option-menu-search"
              :class="{ active: isFilterMenuSearchActive }"
            >
              <span
                class="filter-key-search-icon"
                @click="focusFilterOptionMenuSearch"
              ></span>
              <input
                ref="filterOptionMenuSearchInput"
                type="text"
                name="filter-option-menu-search"
                v-model="filterKeySearch"
                autocomplete="off"
                placeholder="Nach Name oder Label filtern"
                @focus="isFilterMenuSearchFocused = true"
                @blur="isFilterMenuSearchFocused = false"
                @click.stop
                @mousedown.stop
                @keydown.stop
              />
            </div>
          </div>
          <b-dropdown-item
            v-for="item in filteredFilterOptions"
            :key="item.renderKey"
            @click="onFilterCaptionSelect(item.name)"
          >
            {{ formatLabel(item.label) }}
          </b-dropdown-item>
          <div class="empty-filter-option" v-show="hasNoFilterSearchResult">
            Es wurde keine passende Spalte gefunden
          </div>
        </template>
      </generalDropdown>

      <generalDropdown
        className="filter-dropdown condition-filter"
        :alignRight="false"
        v-show="activeFilter.caption"
      >
        <template v-slot:selectFilter>
          <span class="line-clamp">{{ activeFilter.opperandLabel }} </span>
        </template>
        <template v-slot:optionData>
          <b-dropdown-item
            v-for="operator in getOperatorOption"
            :key="operator.label"
            @click="
              addFilterOpperand(
                operator.opperand,
                operator.label,
                operator.backendOpperand
              )
            "
          >
            {{ operator.label }}
          </b-dropdown-item>
        </template>
      </generalDropdown>

      <div
        class="d-block add-new-filter-option"
        v-if="isFilterTypeIsRadioOrCheckBox(activeFilter.type)"
        v-show="activeFilter.caption"
      >
        <generalDropdown
          ref="filterDropRef"
          uniqueReferenceId="filterDropRef"
          :alignRight="false"
          className="filter-dropdown custom-list-filter-dropdown-container"
        >
          <template v-slot:selectFilter>
            <div
              class="selected-filter-checkbox-options-wrap"
              v-if="isFilterTypeIsRadioOrCheckBox(activeFilter.type)"
            >
              <div
                class="selected-filter-checkbox-item"
                v-for="(filter, index) in activeFilter.value"
                :key="index"
              >
                {{ filter }}
              </div>
            </div>
          </template>
          <template v-slot:optionData>
            <div
              class="selected-filter-options-wrap"
              v-if="isFilterTypeIsRadioOrCheckBox(activeFilter.type)"
            >
              <div
                class="selected-filter-options"
                v-for="(filter, index) in activeFilter.value"
                :key="index"
              >
                <span> {{ filter }}</span>

                <i
                  class="fa fa-times"
                  @click.stop="removeSelectedRadioOrCheckboxOption(index)"
                ></i>
              </div>
              <i
                @click="closeDropDown"
                class="fas fa-times-circle close-dropdown-icon"
              ></i>
            </div>
            <div class="filter-checkbox-main">
              <div
                class="filter-checkbox-wrap"
                v-for="selection in getRadioOrCheckboxSelctionValue"
                :key="selection"
              >
                <b-form-checkbox
                  v-model="activeFilter.value"
                  :value="selection"
                >
                  {{ selection }}
                </b-form-checkbox>
              </div>
            </div>
          </template>
        </generalDropdown>
      </div>
      <div v-else-if="activeFilter.type == 'datetime'" class="datetime-filter">
        <input
          type="datetime-local"
          name="filter"
          v-model="activeFilter.value"
        />
      </div>
      <div v-else-if="activeFilter.type == 'date'" class="datetime-filter">
        <input type="date" name="filter" v-model="activeFilter.value" />
      </div>
      <div class="text-filter" v-show="activeFilter.caption" v-else>
        <input name="filter" v-model="activeFilter.value" />
      </div>
    </div>

    <div
      v-if="isEditFilterVisible"
      v-click-outside="hideEditFilter"
      class="filter dropdown edit"
      :class="{
        'edit-radio-or-checkbox-dropdown':
          isActiveFilterIsRadioOrCheckboxWithValue(),
      }"
    >
      <div class="edit-filter-dropdown">
        <generalDropdown className="filter-dropdown" :alignRight="false">
          <template v-slot:selectFilter>
            <span class="line-clamp">{{ activeFilter.opperandLabel }} </span>
          </template>
          <template v-slot:optionData>
            <b-dropdown-item
              v-for="operator in getOperatorOption"
              :key="operator.label"
              @click="
                addFilterOpperand(
                  operator.opperand,
                  operator.label,
                  operator.backendOpperand
                )
              "
            >
              {{ operator.label }}
            </b-dropdown-item>
          </template>
        </generalDropdown>

        <div
          v-if="isFilterTypeIsRadioOrCheckBox(activeFilter.type)"
          class="filter-input add-new-filter-option"
          :class="{ 'd-inline-block': !activeFilter.value.length }"
        >
          <generalDropdown
            ref="filterDropRef"
            uniqueReferenceId="filterDropRef"
            :alignRight="false"
            className="filter-dropdown  custom-list-filter-dropdown-container"
          >
            <template v-slot:selectFilter>
              <div
                class="selected-filter-checkbox-options-wrap"
                v-if="isFilterTypeIsRadioOrCheckBox(activeFilter.type)"
              >
                <div
                  class="selected-filter-checkbox-item"
                  v-for="(filter, index) in activeFilter.value"
                  :key="index"
                >
                  {{ filter }}
                </div>
              </div>
            </template>
            <template v-slot:optionData>
              <div
                class="selected-filter-options-wrap"
                v-if="isFilterTypeIsRadioOrCheckBox(activeFilter.type)"
              >
                <div
                  class="selected-filter-options"
                  v-for="(filter, index) in activeFilter.value"
                  :key="index"
                >
                  <span> {{ filter }}</span>

                  <i
                    class="fa fa-times"
                    @click.stop="removeSelectedRadioOrCheckboxOption(index)"
                  ></i>
                </div>
                <i
                  @click="closeDropDown"
                  class="fas fa-times-circle close-dropdown-icon"
                ></i>
              </div>
              <div class="filter-checkbox-main">
                <div
                  class="filter-checkbox-wrap"
                  v-for="selection in getRadioOrCheckboxSelctionValue"
                  :key="selection"
                >
                  <b-form-checkbox
                    v-model="activeFilter.value"
                    :value="selection"
                  >
                    {{ selection }}
                  </b-form-checkbox>
                </div>
              </div>
            </template>
          </generalDropdown>
        </div>
        <div
          v-else-if="activeFilter.type == 'datetime'"
          class="datetime-filter"
        >
          <input
            type="datetime-local"
            name="filter"
            class="filter-input"
            v-model="activeFilter.value"
          />
        </div>
        <div v-else-if="activeFilter.type == 'date'" class="datetime-filter">
          <input
            type="date"
            name="filter"
            class="filter-input"
            v-model="activeFilter.value"
          />
        </div>
        <div class="text-filter" v-show="activeFilter.caption" v-else>
          <input name="filter" v-model="activeFilter.value" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GeneralDropdown from '../core/general-dropdown.vue';
export default {
  name: 'CustomDatabaseFilter',
  data() {
    return {
      filterKeySearch: '',
      isFilterKeySearchFocused: false,
      isFilterMenuSearchFocused: false,
    };
  },
  props: {
    database: {
      type: Object,
    },
    activeFilter: {
      type: [Object, null],
      default: null,
    },
    isAddFilterVisible: {
      type: Boolean,
      default: false,
    },
    isEditFilterVisible: {
      type: Boolean,
      default: false,
    },
    addFilterCaption: {
      required: true,
      type: Function,
    },
    getSqlKey: {
      required: true,
      type: Function,
    },
    isPaginationDb: {
      type: Boolean,
      default: false,
    },
    isFilterTypeIsRadioOrCheckBox: {
      required: true,
      type: Function,
    },
    getFilterOptions: {
      required: true,
      type: Array,
    },
    getOperatorOption: {
      required: true,
      type: Array,
    },
    hideEditFilter: {
      required: true,
      type: Function,
    },
  },
  methods: {
    formatLabel: function (l) {
      if (l.length > 25) return l.slice(0, 25) + '...';
      else return l;
    },
    focusFilterKeySearch() {
      this.$nextTick(() => {
        this.$refs.filterKeySearchInput?.focus();
      });
    },
    focusFilterOptionMenuSearch() {
      this.$nextTick(() => {
        this.$refs.filterOptionMenuSearchInput?.focus();
      });
    },
    clearFilterKeySearch() {
      this.filterKeySearch = '';
      this.isFilterKeySearchFocused = false;
      this.isFilterMenuSearchFocused = false;
    },
    onFilterCaptionSelect(filterName) {
      this.addFilterCaption(this.getSqlKey(filterName));
      this.clearFilterKeySearch();
    },
    normalizeFilterSearchValue(value) {
      return String(value || '')
        .toLowerCase()
        .trim();
    },
    addFilterOpperand(opperand, label, backendOpperand) {
      this.activeFilter.opperand = opperand;
      this.activeFilter.backendOpperand = backendOpperand;
      this.activeFilter.opperandLabel = label;
      this.$forceUpdate();
    },
    isActiveFilterIsRadioOrCheckboxWithValue() {
      return (
        this.isFilterTypeIsRadioOrCheckBox(this.activeFilter.type) &&
        this.activeFilter.value.length
      );
    },
    removeSelectedRadioOrCheckboxOption(index) {
      this.activeFilter.value.splice(index, 1);
    },
    closeDropDown() {
      this.$refs.filterDropRef.hideDropdown('filterDropRef');
    },
    isNestedFilterSchemaField(schemaField) {
      if (
        !schemaField ||
        !Array.isArray(schemaField.schema) ||
        !schemaField.schema.length
      ) {
        return false;
      }

      if (!schemaField.type) {
        return true;
      }

      return ['objectlist', 'array', 'object', 'list'].includes(
        schemaField.type
      );
    },
  },
  computed: {
    hasFilterSearchValue() {
      return !!this.normalizeFilterSearchValue(this.filterKeySearch);
    },
    isFilterKeySearchActive() {
      return this.isFilterKeySearchFocused || this.hasFilterSearchValue;
    },
    isFilterMenuSearchActive() {
      return this.isFilterMenuSearchFocused || this.hasFilterSearchValue;
    },
    hasNoFilterSearchResult() {
      return this.hasFilterSearchValue && !this.filteredFilterOptions.length;
    },
    filterOptionsWithRenderKey() {
      return this.getFilterOptions.map((item, index) => ({
        ...item,
        renderKey: `filter-option-${index}-${
          item?.name || item?.label || 'key'
        }`,
      }));
    },
    filteredFilterOptions() {
      const searchValue = this.normalizeFilterSearchValue(this.filterKeySearch);
      if (!searchValue) {
        return this.filterOptionsWithRenderKey;
      }

      return this.filterOptionsWithRenderKey.filter((item) => {
        const filterLabel = this.normalizeFilterSearchValue(item?.label);
        const filterName = this.normalizeFilterSearchValue(item?.name);
        return (
          filterLabel.includes(searchValue) || filterName.includes(searchValue)
        );
      });
    },
    getRadioOrCheckboxSelctionValue() {
      if (
        this.database.schema &&
        this.isFilterTypeIsRadioOrCheckBox(this.activeFilter?.type)
      ) {
        const parsedSchema = JSON.parse(this.database.schema);
        const activeFilterType = this.activeFilter.type;
        const activeFilterProperty = this.activeFilter.property;

        let selectedtypeOptions = parsedSchema.find(
          (field) =>
            field.type === activeFilterType &&
            field.name === activeFilterProperty
        );

        if (
          !selectedtypeOptions &&
          activeFilterProperty &&
          this.isPaginationDb
        ) {
          let parentKey = this.activeFilter.parentKey;
          let subKey = this.activeFilter.subKey;

          if (!parentKey || !subKey) {
            for (const schemaField of parsedSchema) {
              if (!schemaField || !schemaField.name) {
                continue;
              }
              if (!this.isNestedFilterSchemaField(schemaField)) {
                continue;
              }

              const schemaParentKey = this.getSqlKey(schemaField.name);
              const prefix = `${schemaParentKey}_`;
              if (!activeFilterProperty.startsWith(prefix)) {
                continue;
              }

              const nestedKey = activeFilterProperty.slice(prefix.length);
              const nestedField = schemaField.schema.find(
                (field) =>
                  field?.name === nestedKey && field.type === activeFilterType
              );
              if (nestedField) {
                parentKey = schemaParentKey;
                subKey = nestedKey;
                selectedtypeOptions = nestedField;
                break;
              }
            }
          }

          if (!selectedtypeOptions && parentKey && subKey) {
            const parentSchemaField = parsedSchema.find(
              (field) =>
                field &&
                this.isNestedFilterSchemaField(field) &&
                this.getSqlKey(field.name) === parentKey
            );
            selectedtypeOptions = parentSchemaField?.schema?.find(
              (field) =>
                field?.name === subKey && field.type === activeFilterType
            );
          }
        }

        if (
          !selectedtypeOptions ||
          !Array.isArray(selectedtypeOptions.options)
        ) {
          return [];
        }
        return selectedtypeOptions.options.map((option) => option.label);
      } else {
        return [];
      }
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasnt a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    GeneralDropdown,
  },
};
</script>
<style scoped>
.custom-filter-component .filter.dropdown {
  max-height: calc(100dvh - 450px);
  overflow-y: auto;

  background-color: white;
  -webkit-box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  box-shadow: 0 0 15px -2px rgb(0 0 0 / 25%);
  border-radius: 6px;
  position: absolute;
  z-index: 60;
  margin-left: 0;
  border: 1px solid #cdcdcd;
  padding: 12px 12px;
  display: flex;
}
.filter.dropdown.is-key-selected {
  padding: 32px 12px;
  overflow-y: unset;
}
.custom-filter-component .filter.dropdown.add select,
.custom-filter-component .filter.dropdown.add input {
  display: inline-block;
}
.custom-filter-component .filter.dropdown.add {
  top: 30px;
  left: 0;
}
.custom-filter-component .filter.dropdown.add:not(.is-key-selected) {
  flex-wrap: wrap;
  width: min(260px, calc(100vw - 48px));
  min-width: 240px;
  padding-top: 0;
}
.custom-filter-component .filter-key-search-container,
.custom-filter-component .filter-option-menu-search-container {
  position: sticky;
  top: 0;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  border-bottom: 1px solid #efefef;
}
.custom-filter-component .filter-key-search-container {
  z-index: 3;
  margin: 0 0 8px;
  padding: 12px 6px 8px;
}
.custom-filter-component .filter-key-search {
  padding: 0;
  height: 36px;
  cursor: auto;
  display: flex;
  width: 100%;
  min-width: 0;
  border-bottom: solid 2px transparent;
  align-items: center;
  transition: border-color 200ms ease;
}
.custom-filter-component .filter-key-search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
}
.custom-filter-component .filter-key-search-icon {
  background-image: url('../../assets/img/search-icon.svg');
  background-size: 17px;
  overflow: hidden;
  display: block;
  width: 22px;
  height: 22px;
  background-position: 0 50%;
  background-repeat: no-repeat;
  margin-top: 0;
  cursor: pointer;
}
.custom-filter-component .filter-key-search input {
  border: 0;
  width: auto;
  flex: 1 1 auto;
  min-width: 0;
  height: 30px;
  padding-left: 8px;
  margin-left: 0;
  cursor: text;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  background: transparent;
  color: #47506e;
}
.custom-filter-component .filter-key-search input:focus {
  outline: none;
}
.custom-filter-component .initial-dropdown-items {
  width: 100%;
  min-width: 0;
}
.custom-filter-component .empty-filter-option {
  color: #8f98ac;
  font-size: 12px;
  padding: 4px 10px 6px;
}
.custom-filter-component .filter-option-menu-search-container {
  z-index: 2;
  padding: 8px 8px 6px;
}
.custom-filter-component .filter-option-menu-search {
  height: 34px;
}
.custom-filter-component .filter-option-menu-search input {
  font-size: 12px;
  height: 28px;
}
.filter.dropdown input[type='datetime-local'] {
  width: 185px;
}
.filter.dropdown .delete-icon {
  position: absolute;
  top: 8px;
  right: 11px;
  line-height: normal;
  height: auto;
}

.filter.dropdown .delete-icon i {
  font-size: 15px;
  color: #a6a6a6;
  position: relative;
  top: -8px;
}
.custom-filter-component .filter.dropdown .initial-dropdown-items li {
  padding: 0;
  min-width: 0;
  width: 100%;
}
.custom-filter-component .key-filter-dropdown ::v-deep .dropdown-menu {
  width: min(260px, calc(100vw - 56px));
  min-width: 240px;
  max-width: min(260px, calc(100vw - 56px));
  padding: 0 12px;
  margin: 7px 0;
}
.custom-filter-component .key-filter-dropdown ::v-deep .dropdown-menu li,
.custom-filter-component .key-filter-dropdown ::v-deep .dropdown-menu li a {
  width: 100%;
}
.filter-dropdown.condition-filter {
  /* background: #cdcdcd; */
  min-width: 180px;
}
.add-new-filter-option {
  margin-left: 24px;
}

.filter-dropdown.custom-list-filter-dropdown-container {
  min-width: 140px;
  width: 220px;
}
.filter-dropdown.condition-filter.show,
.filter-dropdown.custom-list-filter-dropdown-container.show {
  background: #fff;
}

.filter-dropdown.condition-filter.show ::v-deep .customDropdown,
.filter-dropdown.custom-list-filter-dropdown-container.show
  ::v-deep
  .customDropdown {
  margin-top: -1px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-color: #fff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
}
.filter-dropdown.condition-filter.show ::v-deep .dropdown-menu,
.filter-dropdown.custom-list-filter-dropdown-container.show
  ::v-deep
  .dropdown-menu {
  border-color: #fff;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);
  width: 100%;
}

.filter::v-deep.dropdown.add .customDropdown i {
  color: #c0c0c0;
}

.filter-dropdown ::v-deep .customDropdown {
  border: 1px solid #cdcdcd;
  border-radius: 6px;
  justify-content: center;
  width: auto;
  min-width: 120px;
}
.filter-dropdown ::v-deep .customDropdown:hover {
  background: #cdcdcd !important;
}

.filter-dropdown ::v-deep .customDropdown .line-clamp {
  color: #58647d;
  margin-right: 8px;
  font-size: 13px;
  width: calc(100% - 20px);
}
.filter-dropdown ::v-deep .customDropdown .dropdown-toggle-icon {
  padding: 0 0 0 0;
}
.selected-filter-checkbox-options-wrap {
  width: calc(100% - 20px);
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.selected-filter-checkbox-options-wrap .selected-filter-checkbox-item {
  display: inline-block;
  padding: 0 7px;
  background: #ececec;
  margin-right: 4px;
  border: 1px solid #cdcdcd;
  color: #58647d;
  font-size: 13px;
  height: 19px;
  line-height: normal;
  border-radius: 3px;
}
.filter-dropdown.custom-list-filter-dropdown-container
  .selected-filter-options-wrap {
  padding: 10px;
  margin: 0 10px;
  border: 1px solid #cdcdcd;
  border-radius: 6px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  max-height: 100px;
  overflow: auto;
}

.custom-list-filter-dropdown-container
  ::v-deep
  .customDropdown
  .dropdown-toggle-icon {
  margin-left: auto;
}
.custom-list-filter-dropdown-container
  ::v-deep
  .customDropdown
  .dropdown-toggle-icon
  i {
  color: #c0c0c0;
}
.filter-checkbox-main {
  max-height: 170px;
  overflow: auto;
}

.filter.dropdown.edit {
  position: fixed;
  display: block;
  margin-top: 12px;
  margin-left: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 12px;
  overflow-y: unset;
}
.filter.dropdown.edit select,
.filter.dropdown.edit input {
  display: block;
  border-radius: 3px;
  text-align: left;
}
.filter.dropdown.edit ::v-deep .dropdown .btn {
  width: 200px;
}
.edit-radio-or-checkbox-dropdown {
  width: auto;
}
.edit-filter-dropdown {
  display: flex;
  gap: 10px;
}

.edit-filter-dropdown .dropdown-toggle-icon {
  color: #c0c0c0;
}
.selected-filter-options-wrap {
  display: flex;
  font-size: 12px;
  flex-wrap: wrap;
  gap: 4px;
  margin-right: 8px;
  width: calc(100% - 20px);
}
.selected-filter-options-wrap i {
  right: 0;
  position: relative;
  width: 13px;
  opacity: 1;
  font-size: 13px;
  margin-left: auto;
  color: #b5b5b5;
}
.selected-filter-options-wrap .close-dropdown-icon {
  position: absolute;
  right: 15px;
  top: 11px;
}

.selected-filter-options-wrap i:hover {
  color: black;
}

.edit-filter-dropdown .selected-filter-options-wrap .selected-filter-options {
  margin-right: 10px;
}
.filter-checkbox-wrap ::v-deep .custom-checkbox {
  display: flex;
  padding: 0 10px;
  align-items: center;
}

.filter-checkbox-wrap ::v-deep .custom-checkbox .custom-control-input {
  width: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 10px;
}
.filter-checkbox-wrap ::v-deep .custom-checkbox label {
  cursor: pointer;
  font-size: 13px;
  color: #58647d;
}
.filter-checkbox-wrap ::v-deep .custom-checkbox input {
  accent-color: #ff3366;
}
.selected-filter-options {
  background: #ececec;
  border-radius: 3px;
  padding: 0px 10px;
  margin-bottom: 4px;
  border: 1px solid #cdcdcd;
  color: #58647d;
  font-size: 13px;
  height: 19px;
  line-height: normal;
  display: flex;
  align-items: center;
}

.selected-filter-options i {
  color: #a6a6a6;
  font-size: 12px;
  margin-left: 5px;
  display: inline-block;
  opacity: 1;
  width: auto;
}
.text-filter,
.datetime-filter {
  display: inline-flex;
}

.filter ::v-deep .dropdown-item {
  color: #58647d;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  border-radius: 3px;
  padding: 5px 10px;
  white-space: normal;
  width: auto !important;
}
.filter ::v-deep li {
  list-style: none;
  padding: 0 7px;
}
.filter ::v-deep ul {
  padding: 7px 0;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.25);
  border: 1px solid #c0c0c0;
}
.filter ::v-deep li:hover {
  background-color: #ececec;
  border-radius: 5px;
}
.datetime-filter input,
.text-filter input {
  border-radius: 6px;
  border: 1px solid #cdcdcd;
  margin: 0;
  height: 35px !important;
  margin-left: 24px;
  min-width: 135px;
  font-size: 13px;
  color: #58647d;
  padding: 6px 12px;
  text-align: left;
  width: 119px;
}
.mr-3 {
  margin-right: 24px;
}

input:focus {
  outline-width: 0;
}

.custom-filter-component .selected-filter-options span {
  max-width: 100px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
